import { render, staticRenderFns } from "./TableOfContentsLink.vue?vue&type=template&id=0ecb25b0&"
import script from "./TableOfContentsLink.vue?vue&type=script&lang=js&"
export * from "./TableOfContentsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports